(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumis-aluminium-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lumis-editorial-film')) {
  customElements.define('lumis-editorial-film', class extends HTMLElement {
    connectedCallback() {
      this.film = this.querySelector('video');
      if (!this.film || this.dataset.autoplay !== 'true') return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = false;
      this.onPause = () => {
        if (this.inView && !document.hidden && !this.reducedMotion.matches) this.userPaused = true;
      };
      this.onPlay = () => { this.userPaused = false; };
      this.syncPlayback = () => {
        if (!this.inView || document.hidden || this.reducedMotion.matches) {
          this.film.pause();
        } else if (!this.userPaused) {
          this.film.muted = true;
          this.film.play().catch(() => {});
        }
      };
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.syncPlayback();
      }, { threshold: .35 });
      this.film.addEventListener('pause', this.onPause);
      this.film.addEventListener('play', this.onPlay);
      this.reducedMotion.addEventListener('change', this.syncPlayback);
      document.addEventListener('visibilitychange', this.syncPlayback);
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.reducedMotion?.removeEventListener('change', this.syncPlayback);
      if (this.syncPlayback) document.removeEventListener('visibilitychange', this.syncPlayback);
      if (this.film) {
        this.film.removeEventListener('pause', this.onPause);
        this.film.removeEventListener('play', this.onPlay);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumis-announcements"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lumis-announcements'))customElements.define('lumis-announcements',class extends HTMLElement{
connectedCallback(){this.index=0;this.abort=new AbortController();this.addEventListener('click',e=>{const b=e.target.closest('[data-direction]');if(!b)return;const items=[...this.querySelectorAll('.lumis-announcements__pair')];this.index=(this.index+Number(b.dataset.direction)+items.length)%items.length;items.forEach((item,i)=>item.hidden=i!==this.index);},{signal:this.abort.signal});}
disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumis-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lumis-studio-slideshow')){
  customElements.define('lumis-studio-slideshow',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.slides=[...this.querySelectorAll('[data-slide]')];
      this.buttons=[...this.querySelectorAll('[data-slide-to]')];
      this.toggle=this.querySelector('[data-toggle]');
      this.index=0;
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.running=this.dataset.autoplay==='true'&&!this.reduced.matches&&!window.Shopify?.designMode;
      this.visible=true;
      this.focused=false;
      this.hovered=false;
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1,true),options);
      this.querySelector('[data-previous]')?.addEventListener('click',()=>this.go(this.index-1,true),options);
      this.buttons.forEach((button,index)=>button.addEventListener('click',()=>this.go(index,true),options));
      this.toggle?.addEventListener('click',()=>{
        this.running=!this.running;
        if(this.running){this.focused=false;this.hovered=false}
        this.updateToggle();
        this.schedule();
      },options);
      this.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();
        this.go(this.index+(event.key==='ArrowRight'?1:-1),true);
      },options);
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},options);
      this.addEventListener('focusout',event=>{this.focused=this.contains(event.relatedTarget);this.schedule()},options);
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.schedule()}},options);
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule()},options);
      this.addEventListener('touchstart',event=>{this.touchStart=[event.changedTouches[0].clientX,event.changedTouches[0].clientY]}, {...options,passive:true});
      this.addEventListener('touchend',event=>{
        if(!this.touchStart)return;
        const dx=event.changedTouches[0].clientX-this.touchStart[0],dy=event.changedTouches[0].clientY-this.touchStart[1];
        if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.index+(dx<0?1:-1),true);
        this.touchStart=null;
      },{...options,passive:true});
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.running=false;this.updateToggle();this.schedule()},options);
      document.addEventListener('shopify:block:select',event=>{
        const index=this.slides.findIndex(slide=>slide.contains(event.target)||slide===event.target);
        if(index>=0)this.go(index,true);
      },options);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:.15});
      this.observer.observe(this);
      this.dataset.ready='true';
      this.go(0,false);
    }
    go(index,manual){
      if(!this.slides.length)return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{
        const active=i===this.index;
        slide.classList.toggle('is-active',active);
        slide.inert=!active;
        slide.setAttribute('aria-hidden',String(!active));
        this.buttons[i]?.toggleAttribute('aria-current',active);
        if(active)this.buttons[i]?.setAttribute('aria-current','true');
      });
      this.style.color=this.slides[this.index].dataset.ink==='light'?'#fff':'#212020';
      const count=this.querySelector('[data-count]');
      if(count)count.textContent=String(this.index+1).padStart(2,'0');
      if(manual){
        this.running=false;
        const status=this.querySelector('[data-status]');
        if(status)status.textContent=this.slides[this.index].getAttribute('aria-label');
      }
      this.updateToggle();
      this.schedule();
    }
    updateToggle(){
      if(!this.toggle)return;
      const label=this.running?this.toggle.dataset.pause:this.toggle.dataset.play;
      this.toggle.textContent=label;
      this.toggle.setAttribute('aria-label',label);
    }
    schedule(){
      clearTimeout(this.timer);
      if(this.running&&this.visible&&!this.focused&&!this.hovered&&!document.hidden&&this.slides.length>1)
        this.timer=setTimeout(()=>this.go(this.index+1,false),Math.max(6000,Number(this.dataset.interval)||8000));
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.abort=null;this.observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();
})();
